$(document).ready(function () {  
	$(".select2Search").select2({ width:'100%', minimumResultsForSearch: Infinity, dropdownParent:$('.list-wrap .search-type') });
	/* 화살표 변경 선택박스 */
	$(".search-type .select2-selection__arrow").find('b[role="presentation"]').hide().end().append('<i class="icon-select_arrow"></i>');
});

